module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-1-5eca9f6cda57d137f14e894a8c05f704.svg";